import React, {useEffect, useState, useCallback} from 'react';
//DEPENDENCIES
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { CircularProgress } from '@mui/material';
import Swal from "sweetalert2";
import { io } from 'socket.io-client'
import moment from 'moment'
//FUNCTIONS
import { acceptMobileState } from '../services/send_resquest'
import { Oval } from 'react-loader-spinner';
import fetchStates from '../services/get_data';
//ENVIRONMENT VARIABLES
const IP_URL = process.env.REACT_APP_IP_URL
const PORT = process.env.REACT_APP_PORT
const PROTOCOL = process.env.REACT_APP_PROTOCOL
 
const columns = [
  { 
    id: 'equipment', 
    label: 'Equipment',
  },
  {
    id: 'current_status',
    label: 'Current Status',
  },
  {
    id: 'current_reason',
    label: 'Current Reason',
  },
  {
    id: 'time_category',
    label: 'Status Change',
  },
  { id: 'reason', 
    label: 'Reason Change', 
  },
  {
    id: 'start_date',
    label: 'Reason Time',
  },
  {
    id: 'created_at',
    label: 'Received Time',
  },
]

var socket = io(`${PROTOCOL}://${IP_URL}:${PORT}`, {
  secure: true,
  extraHeaders: {
    "Content-Type": "application/json",
  }
})

const FieldNotificationsTable = ({setNotificationSwitch}) => {
  
  const [loadingStates, setLoadingStates] = useState(true)
  const [rowsData, setRowsData] =  useState([])
  const [refreshTrigger, setRefreshTrigger] = useState(false)
  const [loadingAccept, setLoadingAccept] = useState(false)

  const playNotificationSound = useCallback(() => {

    const audio = new Audio('../../../assets/sounds/notification.mp3') 
    audio.play()

  }, [])

  let equipmentsWithPending = []

  useEffect(() => {

    Swal.fire("", `Press OK to activate notification sound`, "warning")

    const get_states = async () => {
      try {
        const data = await fetchStates()
        if (data.status === 200) {
          setRowsData(data.data)
        }
      } catch (error) {
        console.error('Error fetching states:', error.message || error)
      }
    }
    get_states()

    socket.on('connect', () => {
      console.log('connected')
    })
  
    socket.on('disconnect', () => {
      console.log('disconnected')
    })
  
    socket.on('new_state_added', (response) => {
      console.log('previous to sound') 
      playNotificationSound() 
      setRefreshTrigger((prev) => !prev)
    })

    return () => {
      socket.off('connect')
      socket.off('disconnect')
      socket.off('new_state_added')
    }
  }, [])

  useEffect(() => {
    console.log('update data on new state socket call')
    const get_states = async () => {
      try {
        const data = await fetchStates()
        if (data.status === 200) {
          setRowsData(data.data)
        }
      } catch (error) {
        console.error('Error fetching states:', error.message || error)
      }
    }
    get_states()
  }, [refreshTrigger])

  useEffect(() => {
    if (rowsData.length > 0) {
      console.log('row', rowsData)
      setLoadingStates(false)
      setNotificationSwitch(true)
    } else {
      setNotificationSwitch(false)
    }
  }, [rowsData])

  const handleAccept = async (state) => {
    console.log('state from handle accept', state)
    const startDateMoment = moment(state.start_date, 'HH:mm DD-MMM-YYYY');
    const hour = startDateMoment.format('HH:mm');
    const date = startDateMoment.format('DD-MMM-YYYY');
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `The ${state.reason} will be accepted for ${state.equipment} at ${hour} on ${date}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, accept it",
      cancelButtonText: "No",
    });
  
    if (result.isConfirmed) {
      try {

        setLoadingAccept(true)

        const response = await acceptMobileState(state)

        setLoadingAccept(false)

        console.log('response from postRequest function', response)
        if (response.status === 200) {
          removeRowsById(state.app_state_id)
          Swal.fire("Good Job!", `Dispatch changed equipment status to ${state.reason} for ${state.equipment} at ${hour} on ${date}`, "success")
        } else {
          Swal.fire("Action not completed", response.message, "error")
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire("Error!", "Could not send the request. Please try again.", "error")
      }
    }
  }

  const handleRemove = async (state) => {
    console.log("handle remove", state); 
    
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Dispatch will reject ${state.reason} for ${state.equipment}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject it",
      cancelButtonText: "No, keep it",
    });
  
    if (result.isConfirmed) {
      try {
        const response = await fetch(`http://${IP_URL}:${PORT}/decline_new_tum`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(state)
        })
        const res = await response.json();
        console.log('response in handleRemove from decline state', res)
        if (res.status == 200) {
          // console.log("DATA", data)
          removeRowsById(state.app_state_id)
          Swal.fire("Rejected!", `Dispatch rejected the  reason change`, "success");
          Swal.fire("Rejected!", ` Dispatch rejected ${state.reason} change for ${state.equipment}`, "success");
         
        } else {
          Swal.fire("Action not completed!", res.message, "error");
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire("Error!", "Could not delete the item. Please try again.", "error");
      }
    }
  }

  const handleRows = (new_state) => {
    // console.log('before add the state', rowsData)
    const updatedRows = ([...rowsData, new_state])
    // console.log(`update rows state ${updatedRows}`)
    setRowsData(updatedRows)
  }

  const removeRowsById = (app_state_id) => {
    setRowsData((prevRows) => prevRows.filter((row) => row.app_state_id !== app_state_id))
  }

  const isEquipmentHasPending = (equipment, id_row) => {
    const pending = equipmentsWithPending.some(item => item.equipment === equipment)

    if(!pending) {
      equipmentsWithPending.push({equipment: equipment, row: id_row})
      return false
    } else {
      return true
    }
  }

  return (
    <Paper sx={{ width: '80%', overflow: 'hidden', alignSelf: 'center'}}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead style={{ height: '50px' }}>
            <TableRow style={{ justifyContent: 'center' }}>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{ backgroundColor: '#1c4b64', color: '#f0f0f0', fontWeight: 700 }}
                >
                  {column.label}
                </TableCell>
              ))}
              <TableCell style={{ backgroundColor: '#1c4b64', color: '#f0f0f0', fontWeight: 700 }}>
                Accept
              </TableCell>
              <TableCell style={{ backgroundColor: '#1c4b64', color: '#f0f0f0', fontWeight: 700 }}>
                Reject
              </TableCell>
            </TableRow>
          </TableHead>
          {rowsData.length === 0?
          <TableBody>
            <tr>
              <td colSpan={9}>No TUM state request pending</td>
            </tr>
          </TableBody>
            :
            <TableBody>
            {!loadingStates ? (
              rowsData
                .map((row) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      let row_color = '';
                      if (column.id === 'time_category' || column.id === 'current_status') {
                        if (row[column.id] === 'Down') row_color = '#ed3030';
                        if (row[column.id] === 'Operating') row_color = '#76ed66';
                        if (row[column.id] === 'Standby') row_color = '#c9d4c8';
                        if (row[column.id] === 'Delay') row_color = '#f7f747';
                      }
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} style={{ backgroundColor: row_color }}>
                          {value}
                        </TableCell>
                      )
                    })}
                      { !isEquipmentHasPending(row.equipment, row.app_state_id) ?
                        <>
                        { loadingAccept ?
                          <TableCell key={`${row.code}-accept`}>
                          <button key={row.app_state_id} disabled style={{backgroundColor: 'gray', height: '30px', color: '#ffffff', border: 'none', borderRadius: '2px', width: '58px', fontSize: 20, alignItems: 'center', justifyContent: 'center'}}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}> 
                              <Oval
                                color="#00BFFF" 
                                height={20}
                                width={20}
                              />
                            </div>
                          </button>
                          </TableCell>
                          :
                          <TableCell key={`${row.code}-accept`}>
                            <button key={row.app_state_id} onClick={() => handleAccept(row)} style={{backgroundColor: '#76ed66', height: '30px', color: '#ffffff', border: 'none', borderRadius: '2px', width: '58px', fontSize: 20}}>✔</button>
                          </TableCell>
                        } 
                          <TableCell key={`${row.code}-reject`}>
                            <button onClick={() => handleRemove(row)} style={{backgroundColor: 'orange', height: '30px', color: '#ffffff', border: 'none', borderRadius: '2px', width: '58px', fontSize: 20, justifyItems: 'center'}}>x</button>
                          </TableCell>
                        </>
                        :
                        <>
                          <TableCell key={`${row.code}-accept`}>
                            <button key={row.app_state_id} onClick={() => handleAccept(row)} style={{backgroundColor: 'gray', height: '30px', color: '#ffffff', border: 'none', borderRadius: '2px', width: '58px', fontSize: 20}} disabled>✔</button>
                          </TableCell>
                          <TableCell key={`${row.code}-reject`}>
                            <button onClick={() => handleRemove(row)} style={{backgroundColor: 'gray', height: '30px', color: '#ffffff', border: 'none', borderRadius: '2px', width: '58px', fontSize: 20, justifyItems: 'center'}} disabled>x</button>
                          </TableCell>
                        </>
                      }
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 2} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          }
        </Table>
      </TableContainer>
    </Paper>
  )
}


export default FieldNotificationsTable